import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  private USER_SUBSCRIPTION = 'user-subscription';
  private showCancelledTrialBanner = 'showCancelledTrialBanner';

  constructor() {}

  setUserSubscription(data: any) {
    localStorage.setItem(this.USER_SUBSCRIPTION, JSON.stringify(data));
  }

  getUserSubscription() {
    let data = localStorage.getItem(this.USER_SUBSCRIPTION);
    if (data) return JSON.parse(data);
    return null;
  }

  deleteUserSubscription() {
    return localStorage.removeItem(this.USER_SUBSCRIPTION);
  }

  setShowCancelledTrialBanner(value: boolean) {
    localStorage.setItem(this.showCancelledTrialBanner, JSON.stringify(value));
  }

  clearcancelledTrialBanner() {
    return localStorage.removeItem(this.showCancelledTrialBanner);
  }

  getShowCancelledTrialBanner(): boolean {
    const value = localStorage.getItem(this.showCancelledTrialBanner);
    return value ? JSON.parse(value) : false;
  }

}
